import { createSelector } from 'reselect';

const selectCrmSettings = (state: any) => state.crmSettings;


export const selectCrmSettingsCurrentItem = createSelector([selectCrmSettings], (crmSettings) => crmSettings.current);

export const selectCrmSettingsListItems = createSelector([selectCrmSettings], (crmSettings) => crmSettings.list);

export const selectCrmSettingsItemById = (itemId: any) =>
    createSelector(selectCrmSettingsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectCrmSettingsQueryItems = createSelector([selectCrmSettings], (crmSettings) => crmSettings.query);

export const selectCrmSettingsCreatedItem = createSelector([selectCrmSettings], (crmSettings) => crmSettings.create);

export const selectCrmSettingsUpdatedItem = createSelector([selectCrmSettings], (crmSettings) => crmSettings.update);

export const selectCrmSettingsReadItem = createSelector([selectCrmSettings], (crmSettings) => crmSettings.read);

export const selectCrmSettingsDeletedItem = createSelector([selectCrmSettings], (crmSettings) => crmSettings.delete);

export const selectCrmSettingsSearchedItems = createSelector([selectCrmSettings], (crmSettings) => crmSettings.search);

export const selectCrmSettingsItemsCount = createSelector([selectCrmSettings], (crmSettings) => crmSettings.count);

export const selectCrmSettingsItemsFilter = createSelector([selectCrmSettings], (crmSettings) => crmSettings.filter);

export const selectCrmSettingsSummaryItems = createSelector([selectCrmSettings], (crmSettings) => crmSettings.summary);